import React from 'react';
import StorylaneDemoEmbed from '@Client/runner.shared/StorylaneDemoEmbed/StorylaneDemoEmbed';

interface IEmptyStateProps {
  summaryText?: string;
  bodyText?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  demoUrl?: string;
}

const EmptyState = ({
  summaryText = '',
  bodyText = '',
  buttonText = '',
  onButtonClick,
  demoUrl
}: IEmptyStateProps) => {
  return (
    <div
      className={`empty-state-container ${demoUrl ? 'show-demo' : ''}`}
      data-testid="empty-state-container"
    >
      <div
        className={`empty-state align-center pb-30 ${demoUrl ? '' : 'pt-50'}`}
      >
        <div>
          <h4 className="empty-state__summary">{summaryText}</h4>
          {!demoUrl && (
            <>
              <h5
                className="empty-state__text"
                dangerouslySetInnerHTML={{ __html: bodyText }}
              />
              <br />
            </>
          )}
        </div>
        {demoUrl && <StorylaneDemoEmbed demoUrl={demoUrl} />}
        {buttonText && onButtonClick && (
          <button onClick={onButtonClick} className="btn green">
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
